var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoverdossie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.442 16.8423L10.1392 15.5394L13.4893 12.1893L10.1392 8.8624L11.442 7.55957L14.7921 10.9097L18.119 7.55957L19.4219 8.8624L16.0717 12.1893L19.4219 15.5394L18.119 16.8423L14.7921 13.4921L11.442 16.8423Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71094 1.94238H17.4795C18.0136 1.94238 18.4712 2.13236 18.8516 2.5127C19.2317 2.89292 19.4218 3.34993 19.4219 3.88379V6.61621C18.8436 6.13507 18.189 5.74327 17.4795 5.45898V3.88379H8.91016L6.96777 1.94238H1.94238V13.5947H7.65332C7.78694 14.282 8.01839 14.9339 8.33105 15.5371H1.94238C1.40852 15.5371 0.951526 15.3469 0.571289 14.9668C0.190951 14.5865 0 14.1288 0 13.5947V1.94238C0 1.40829 0.190951 0.950651 0.571289 0.570312C0.951564 0.190132 1.40843 2.31726e-05 1.94238 0H7.76855L9.71094 1.94238Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoverdossie);
export default __webpack_public_path__ + "static/media/removerdossie.1ae0a14667b5606098fb4342f0fed1df.svg";
export { ForwardRef as ReactComponent };